import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import logo from "../assets/logo1.png"
const Logo = styled.img`
    width: 100%;
    max-width: 100px;
    height: 100px;
    margin-bottom: 20px;
    borderRadius: 30px;  
`;

const SidebarWrapper = styled.div`
    height: 100%;
    width: 250px;
    position: fixed;
    top: 0;
    left: 0;
    background-color: #F5C000;
    padding-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const SidebarLink = styled.a`
    display: flex;
    align-items: center;
    padding: 15px 20px;
    text-decoration: none;
    font-size: 18px;
    color: #eee;
    transition: 0.3s;
    width: 100%;
    box-sizing: border-box;
    margin-top: 8px;

    &:hover {
        color: #fff;
        background: #A49590;
    }

    ${(props) => props.active && `
        color: #fff;
        background: #A49590;
    `}
`;

const Icon = styled.span`
    margin-right: 10px;
`;

const MainContent = styled.div`
    margin-left: 250px;
    padding: 20px;
`;

const Sidebar = () => {
    const currentPath = window.location.pathname;

    const handleLogout = () => {
        // Clear local storage
        localStorage.clear();
        // Navigate to the home page
        window.location.href = "/provider-login";
    };

    return (
        <SidebarWrapper>
            <Logo src={logo} alt="Company Logo" />
            <SidebarLink href="/user-management" active={currentPath === '/user-management'}>
              
                User Management
            </SidebarLink>
            <SidebarLink href="/sub-admin-management" active={currentPath === '/sub-admin-management'}>
                
                Sub Admin Management
            </SidebarLink>
            <SidebarLink href="/category-management" active={currentPath === '/category-management'}>
               
                Category Management
            </SidebarLink>
            <SidebarLink href="/portfolio-management" active={currentPath === '/portfolio-management'}>
                
                Portfolio Management
            </SidebarLink>
            <SidebarLink href="/community-management" active={currentPath === '/community-management'}>
             
             Community Management
            </SidebarLink>
            <SidebarLink href="/contact-management" active={currentPath === '/contact-management'}>
             
                Contact Management
            </SidebarLink>
            <SidebarLink href="/" onClick={handleLogout} topMargin>
                <Icon><FontAwesomeIcon icon={faSignOutAlt} /></Icon>
                Logout
            </SidebarLink>
        </SidebarWrapper>
    );
};

export default Sidebar;
